// extracted by mini-css-extract-plugin
module.exports = {"header-logo":"NavBar_header-logo__2SJ1X"};